export default __webpack_public_path__ + "static/media/landing-coffee.542d4a0d.webp";